import Immerable from '@naruto/naruto-models/src/types/GeneralImmer';

class TextParser extends Immerable {
  /**
   * 名稱 : spacesToDiamonds
   * 功能 : 將空白以鑽石取代
   */
  spacesToDiamonds = (content: string): string => content.replace(/\u0020/g, '\u2666');

  /**
   * 名稱 : doubleSpace2FullSpace
   * 功能 : 兩個半形空白轉全型空白
   */
  doubleSpace2FullSpace = (text: string): string => text.replace(/ {2}/g, '\u3000');

  /**
   * 名稱 : getCharacterLength
   * 功能 : 取得字元寬度
   */
  getCharacterLength = (ch: string): number => {
    const chCode = ch.charCodeAt(0);
    if (chCode >= 0 && chCode <= 255) {
      return 1;
    }
    return 2;
  };

  /**
   * 名稱 : getShortText
   * 功能 : 縮短字串長度
   */
  getShortText = (text: string, maxLength = text.length, shortString = '...'): string => {
    let currentLength = 0;
    let endIndex = 0;
    for (let i = 0; i < Object.keys(text).length; i += 1) {
      const ch = text[i];
      const chLength = this.getCharacterLength(ch);
      if (currentLength + chLength <= maxLength) {
        currentLength += chLength;
        endIndex += 1;
      } else {
        endIndex -= 1;
        break;
      }
    }
    if (endIndex === text.length) {
      return text;
    }
    return `${text.substring(0, endIndex + 1)}${shortString}`;
  };

  /**
   * 名稱 : getFormatString
   * 功能 : 取代特定字串裡面 `{0}` 之文字
   */
  getFormatString = (originString: string, insertString: string): string => {
    let formatString = '';
    formatString = originString.replace(/{(\d+)}/g, (match, number) =>
      typeof insertString[number] !== 'undefined' ? insertString : match
    );
    return formatString;
  };

  /**
   * 功能 : 取代特定字串裡面 {0}, {1}... 之文字
   * @param {string} originString 原始字串
   * @param {string[]} insertStrings 欲插入的字串
   * @returns {string} 取得取代後的字串
   */
  getFormatStrings = (originString: string, insertStrings: string[] = []): string => {
    let formatString = originString;
    for (let i = 0; i < insertStrings.length; i += 1) {
      formatString = formatString.replace(/{(\d+)}/, (match, number) =>
        typeof insertStrings[number] !== 'undefined' ? `${insertStrings[i]}` : match
      );
    }
    return formatString;
  };

  /**
   * 名稱 : count
   * 功能 : 將數字轉換為千分位格式
   */
  formatWithThousandSeparator = (count: number): string => count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  /**
   * 名稱 : formatLabel
   * 功能 : 將字串格式化為標籤
   */
  formatLabel = (str: string): string => {
    if (!str) return '';
    const result = str.replace(/_/g, ' ');
    return result.charAt(0).toUpperCase() + result.slice(1);
  };
}

export default TextParser;
